export default "__VITE_ASSET__CEoCCwzM__"